import {Suspense} from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {ProfilePictureCard} from "./components/ProfilePictureCard";
import {Page} from "_page/Page";
import ProfileImageSuspense from "_components/suspense/ProfileImageSuspense";
import ProfileTab from "./components/ProfileTab";

const Profile = () => {
    return (
        <Page>
            <Row>
                <Col xl={3} lg={6}>
                    <Suspense fallback={<ProfileImageSuspense/>}>
                        <ProfilePictureCard/>
                    </Suspense>
                </Col>
                <Col xl={9} lg={6}>
                    <ProfileTab/>
                </Col>
            </Row>
        </Page>
    )
};


export default Profile;
